import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import type { QueryClient } from '@tanstack/react-query'
import type { RouterContext } from '@/types/router'

export function createRouter(queryClient: QueryClient) {
  return createTanStackRouter({
    routeTree,
    context: {
      queryClient,
      auth: {
        session: null,
        ready: Promise.resolve(),
      },
    } satisfies RouterContext,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
  })
}

export type AppRouter = ReturnType<typeof createRouter>
